import React from 'react';

export const OrderProgressPills = ({ currentTab, onChange, totalNew, totalInProgress, totalDelivering, totalReady, companySettings }) => {
  const renderPill = (text, key, isActive, ind, count) => {
    return (
      <button
        key={key}
        type="button"
        onClick={() => onChange(key)}
        className={`py-2 px-5 mr-2 mb-1 ${isActive
          ? ` bg-indigo-600 border border-transparent rounded-3xl shadow-sm inline-flex justify-center items-center text-sm font-medium
          text-white hover:bg-indigo-700 disabled:opacity-50`
          : `bg-white border border-gray-300 rounded-3xl shadow-sm text-sm font-medium text-gray-700 inline-flex justify-center items-center
            hover:bg-gray-50 disabled:opacity-50`}`}
      >
        {text}{count >= 0 ? ` (${count})` : ''}
      </button>
    );
  };

  return (
    <div className="my-8 select-none flex flex-row flex-wrap">
      {renderPill(companySettings && companySettings.separate_in_progress ? 'New' : 'New & In Progress', 'new', currentTab === 'new', 0, totalNew)}
      {companySettings && companySettings.separate_in_progress && renderPill('In Progress', 'in_progress', currentTab === 'in_progress', 1, totalInProgress)}
      {companySettings && !companySettings.skip_ready && renderPill('Ready', 'ready', currentTab === 'ready', 2, totalReady)}
      {companySettings && companySettings.separate_delivering && renderPill('Delivering', 'delivering', currentTab === 'delivering', 3, totalDelivering)}
      {renderPill('Closed', 'closed', currentTab === 'closed', 4)}
    </div>
  );
};
